var $75fa0397632d287b$exports = {};
$75fa0397632d287b$exports = {
    "dismiss": `Odstranit`
};


export {$75fa0397632d287b$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
